import React, { useContext, useMemo } from 'react';
import { getCircleColor } from '../costBenchmarkHelpers.js';
import PropTypes from 'prop-types';
import { CostBenchmarkContext } from '../../../contexts/costBenchmarkingContext.js';

const ChartDot = React.memo(function ChartDot({ data, x, y, index, uniqueId }) {
  const { setActiveTooltip } = useContext(CostBenchmarkContext);
  const dotId = `dot-idx-${index}-${uniqueId}`;

  const getHexColor = (type) => {
    const style = getComputedStyle(document.body);
    switch (type) {
      case 'High':
        return style.getPropertyValue('--forge-theme-error').trim() || '#eb0000';
      case 'Low':
        return style.getPropertyValue('--forge-theme-success').trim() || '#00a651';
      default:
        return style.getPropertyValue('--forge-theme-primary').trim() || '#00a651';

    }
  };
  
  const fillColor = useMemo(() => getHexColor(data.classification), [data.classification]);

  const handleMouseEnter = (e) => {
    e.stopPropagation();
    setActiveTooltip({ visible: true, targetId: dotId, data });
  };

  const handleMouseLeave = (e) => {
    e.stopPropagation();
    setActiveTooltip({ visible: false, targetId: null, data: null });
  };

  return (
    <circle
      id={dotId}
      className={getCircleColor(data.classification)}
      cx={x}
      cy={y}
      r={6}
      fill={fillColor}
      style={{ cursor: 'crosshair', pointerEvents: 'all' }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    />
  );
});

ChartDot.propTypes = {
  data: PropTypes.object,
  x: PropTypes.number,
  y: PropTypes.number,
  index: PropTypes.number,
  uniqueId: PropTypes.string
};

export default ChartDot;
